import WOW from 'wowjs';

import '../landing.css'

import { useEffect, useState } from "react";
import Header from '../components/Header';
import Footer from '../components/Footer';

const FinanciacionPage = () => {

    const [visible, setVisible] = useState(true);

    useEffect(() => {
        new WOW.WOW().init();
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const handleClick = ({
        phone = "16892589039",
        message = "Hola, quiero más información",
    }) => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;

        const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

        // URL de WhatsApp
        const whatsappURL = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}&app_absent=0`;

        // En iOS Safari, abrir directamente
        if (isIOS) {
            window.location.href = whatsappURL;
        } else {
            window.open(whatsappURL, "_blank", "noopener,noreferrer");
        }
    };

    return (
        <>
            <Header currentSection='financiacion' />
            <section id='financiacion' className="financiacion w-100 pt-130">
                <div className='container d-flex flex-column justify-content-center align-items-center'>
                    <h1 className="fw-bold text-primary fw-bold text-center">¡Tú tranquilidad no puede esperar!</h1>
                    <div className='row align-items-center mb-5 z-1'>
                        <div className='col-12 col-md-7'>
                            <div className='p-4 z-1 wow slideInLeft'>
                                <h1 className="parrafo text-secondary text-justify" style={{ textAlign: "justify"}}>
                                    Sabemos que tu futuro y tu seguridad no pueden esperar. El primer paso en tu proceso migratorio es el más importante y debe darse sin demoras.<br /><br />
                                    En Asilo A Tu Alcance, la falta de dinero no será un obstáculo. Abrimos la puerta al financiamiento para que inicies tu solicitud de inmediato:<br /><br />
                                    Con una cuota inicial de solo <strong>$1,000 USD.</strong><br /><br />
                                    El saldo restante lo cubres en cómodas cuotas escalonadas, ajustadas al avance de tu caso. Invertir en tu futuro es invertir en tu paz, sin comprometer tu estabilidad económica actual.<br /><br />
                                    Tu seguridad es urgente. Nosotros te acompañamos. ¡Empecemos hoy!
                                </h1>
                                <br />
                                <br />
                                <div className='text-center mb-5'>
                                    <button onClick={handleClick} className="border-0 text-white text-decoration-none px-3 py-3 rounded-4 mt-5 text-center wow bounce z-1 fs-5" style={{ fontSize: 'clamp(0.9rem, 5vw, 1rem)', backgroundColor: '#B1802D' }}>
                                        <i className="bi bi-whatsapp"></i> Habla con nosotros
                                    </button>
                                </div>
                                <h1 className="parrafo text-secondary" style={{ textAlign: "justify"}}>
                                    <span className='fw-bold fs-4'>Nuestro servicio incluye:</span><br /><br />
                                    •	Diligenciamiento completo del formulario de solicitud de asilo.<br />
                                    •	Redacción profesional de tu declaración de hechos.<br />
                                    •	Traducción certificada de tus documentos personales.<br />
                                    •	Traducción certificada de hasta 8 páginas de pruebas que desees anexar.<br />
                                    •	Solicitud del permiso de trabajo.<br />
                                    •	Orientación para solicitar el número de Seguro Social.<br />
                                    •	Acompañamiento durante todo el proceso de solicitud de asilo.<br />
                                    •	Preparación personalizada para la entrevista de miedo creíble (si aplica a tu caso).<br />
                                    •	Breve orientación previa a cada corte migratoria (si aplica a tu caso).
                                </h1>
                                <div className='text-center mb-5 mt-5'>
                                    <button onClick={handleClick} className="border-0 text-white text-decoration-none px-3 py-3 rounded-4 mt-5 text-center wow bounce z-1" style={{ fontSize: 'clamp(1rem, 2vw, 1.2rem)', backgroundColor: '#B1802D' }}>
                                        <i className="bi bi-whatsapp"></i> Inicia tu proceso con nosotros
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-md-5'>
                            <div class="d-flex justify-content-center mt-5">
                                <div className='financiacion-image shadow'></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <div className="chat-container">
                {visible && (
                    <div className="chat-popup">
                        <div className="chat-text">
                            <strong>Asilo a tu Alcance</strong><br />
                            ¡Hola! Soy tu asesor de Inmigración. ¿Cómo te puedo ayudar?
                        </div>
                        <span className="close-btn" onClick={() => setVisible(false)}>×</span>
                    </div>
                )}
                <div className="chat-icon">
                    <button onClick={handleClick} className="border-0 btn-wsp d-flex align-items-center justify-content-center">
                        <i className="bi bi-whatsapp icono"></i>
                    </button>
                </div>
            </div>
        </>
    );
}

export default FinanciacionPage;